import { cn } from '@/shared/lib/cn';
import { initials } from '@/shared/lib/format';

const PALETTE = [
  'bg-primary-soft text-primary',
  'bg-success-soft text-success',
  'bg-warning-soft text-warning',
  'bg-violet-soft text-violet',
  'bg-info-soft text-info',
  'bg-danger-soft text-danger',
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

interface AvatarProps {
  firstName?: string | null;
  lastName?: string | null;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

/** Initials avatar with a stable per-name colour. */
export function Avatar({ firstName, lastName, size = 'sm', className }: AvatarProps) {
  const label = initials(firstName, lastName) || '?';
  const tone = PALETTE[hash(`${firstName ?? ''}${lastName ?? ''}`) % PALETTE.length];
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold',
        size === 'xs' && 'size-5 text-[9px]',
        size === 'sm' && 'size-6 text-2xs',
        size === 'md' && 'size-8 text-xs',
        tone,
        className,
      )}
    >
      {label}
    </span>
  );
}
